import { Container, Row } from 'react-bootstrap';
import React, { useState } from 'react';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import { DEFAULT_PAGE_SIZE, MAX_PAGE_SIZE } from '@components/table';

const Pagination = (props: any) => {
  const {
    paginationBarClasses = null,
    pageSize,
    setPageSize,
    pageList = [10, 25, 30, 50, 100, 'All'],
    rows,
    pageIndex,
    setPageIndex = null,
    setPageLoading,
    gotoPage = (index: number) => {
      setPageIndex?.(index);
    },
    canPreviousPage,
    previousPage = () => {
      setPageIndex?.(pageIndex - 1);
    },
    canNextPage,
    nextPage = () => {
      setPageIndex?.(pageIndex + 1);
    },
    pageCount,
    ...rest
  } = props;

  const convertDisplayPageSize = (pSize: any) => {
    if (isValueEmpty(pSize)) return DEFAULT_PAGE_SIZE;
    return pSize === MAX_PAGE_SIZE ? 'All' : Number(pSize);
  };

  const convertPageSize = (pSize: any) => {
    if (isValueEmpty(pSize)) return DEFAULT_PAGE_SIZE;
    return pSize === 'All' ? MAX_PAGE_SIZE : Number(pSize);
  };

  const [displayPageSize, setDisplayPageSize] = useState(convertDisplayPageSize(pageSize));

  return (
    <div className={paginationBarClasses ? paginationBarClasses : '' + ' pagination'}>
      <Container>
        <Row>
          <div>
            <select
              className="form-control"
              value={displayPageSize}
              style={{ font: 'inherit', width: 'auto' }}
              onChange={(e) => {
                const ev = e.target.value;
                setDisplayPageSize(String(ev));
                setPageSize(convertPageSize(ev));
              }}
            >
              {pageList.map((pSize: any, i: any) => (
                <option key={i} value={String(pSize)}>
                  {pSize}
                </option>
              ))}
            </select>
          </div>
          <div style={{ paddingTop: '0.4rem' }}>
            <span className="pagination_showing">
              Showing {rows.length === 0 ? '0' : pageIndex * pageSize + 1} -{' '}
              {pageIndex * pageSize + pageSize > rows.length ? rows.length : pageIndex * pageSize + pageSize} of{' '}
              {rows.length}
            </span>
          </div>
          <div>
            {rows.length > pageSize ? (
              <div className="float-right">
                <button
                  onClick={(e) => {
                    if (paginationBarClasses) {
                      setPageLoading(true);
                    }
                    e.preventDefault();
                    gotoPage(0);
                  }}
                  disabled={!canPreviousPage}
                  className="btn btn-light"
                >
                  {'<<'}
                </button>{' '}
                <button
                  onClick={(e) => {
                    if (paginationBarClasses) {
                      setPageLoading(true);
                    }
                    e.preventDefault();
                    previousPage();
                  }}
                  disabled={!canPreviousPage}
                  className="btn btn-light"
                >
                  {'<'}
                </button>{' '}
                <button
                  onClick={(e) => {
                    if (paginationBarClasses) {
                      setPageLoading(true);
                    }
                    e.preventDefault();
                    nextPage();
                  }}
                  disabled={!canNextPage}
                  className="btn btn-light"
                >
                  {'>'}
                </button>{' '}
                <button
                  onClick={(e) => {
                    if (paginationBarClasses) {
                      setPageLoading(true);
                    }
                    e.preventDefault();
                    gotoPage(pageCount - 1);
                  }}
                  disabled={!canNextPage}
                  className="btn btn-light"
                >
                  {'>>'}
                </button>{' '}
              </div>
            ) : (
              ''
            )}
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default Pagination;
